import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface AchievementBadge {
  id:           string;
  label:        string;
  description:  string;
  icon:         string;
  color:        string;
  unlocked:     boolean;
  unlockedAt?:  string;
}

export interface DarkAchievementConfig {
  title?:      string;
  headerIcon?: string;
  badges:      AchievementBadge[];
}

@Component({
  selector: 'app-dark-achievement-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dark-achievement-card.component.html',
  styleUrl:    './dark-achievement-card.component.scss',
})
export class DarkAchievementCardComponent {
  @Input() config!: DarkAchievementConfig;
  @Input() loading = false;

  activeBadgeId: string | null = null;

  gradId(id: string): string {
    return `ach-grad-${id}`;
  }

  get unlocked(): number {
    return this.config?.badges.filter(b => b.unlocked).length ?? 0;
  }

  get total(): number {
    return this.config?.badges.length ?? 0;
  }

  get progressPct(): number {
    return this.total ? Math.round((this.unlocked / this.total) * 100) : 0;
  }

  progressColor(): string {
    if (this.progressPct >= 80) return '#4ade80';
    if (this.progressPct >= 40) return '#fb923c';
    return '#6366f1';
  }

  showTooltip(badgeId: string): void {
    this.activeBadgeId = badgeId;
  }

  hideTooltip(): void {
    this.activeBadgeId = null;
  }
}
